import { useEffect } from "react";

import { signalRConstants } from "../../../constants";
import { addListeners, removeListeners } from "../../../../../system";

const {
  receiveMessageconnectionKey,
  receiveNewConversationConnectionKey,
  conversationUpdatedConnectionKey,
} = signalRConstants;

/**
 * Registers inbox SignalR message/conversation listeners and cleans them up.
 * Brand group join/leave stays with the caller via addBrandToGroup / removeBrandGroup.
 */
const useInboxSignalRListeners = ({
  connection,
  connectionState,
  connectionId,
  groupCreated,
  addBrandToGroup,
  removeBrandGroup,
  onReceiveMessage,
  onNewConversation,
  onConversationUpdated,
}) => {
  useEffect(() => {
    //Create group using brandId for survey inbox on server SignalR
    addBrandToGroup?.();

    addListeners({
      connection,
      listeners: [
        {
          key: receiveMessageconnectionKey,
          callbackFunction: (data) => {
            data && onReceiveMessage?.(data);
          },
        },
        {
          key: receiveNewConversationConnectionKey,
          callbackFunction: (data) => {
            data && onNewConversation?.(data);
          },
        },
        {
          key: conversationUpdatedConnectionKey,
          callbackFunction: (conversationId) => {
            onConversationUpdated?.(conversationId);
          },
        },
      ],
    });

    return () => {
      //Remove group, we created for survey inbox
      if (groupCreated) {
        removeBrandGroup?.();
      }
      removeListeners({
        connection,
        listeners: [
          receiveMessageconnectionKey,
          receiveNewConversationConnectionKey,
          conversationUpdatedConnectionKey,
        ],
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [connection, connectionState, connectionId]);
};

export default useInboxSignalRListeners;
